import axios from 'axios'
import { API_BASE_URL } from '../constants/system'

/**
 * Thin client for the user-facing session-jobs route (T4):
 * `PUT /agentkit/agent/:customer/session/:id/jobs`.
 *
 * The body carries the COMPLETE new set, never a delta — same contract as the
 * gateway/plugin route the `set_jobs` tool calls. The response mirrors the
 * write: `jobs` is the new selection, `job` the maintained primary
 * (`jobs[0]`, or "" when the set is empty).
 */
export interface SetSessionJobsResponse {
  jobs: string[]
  job: string
}

export const agentSessionJobsApi = {
  async setJobs(customer: string, sessionId: string, jobs: string[]): Promise<SetSessionJobsResponse> {
    const res = await axios.put<SetSessionJobsResponse>(
      `${API_BASE_URL}/agentkit/agent/${customer}/session/${sessionId}/jobs`,
      { jobs },
    )
    return res.data
  },
}
